export const BONUS_ROLLING_MODAL_WAS_SHOWN = 'bonusRollingModalWasShown';

export const BONUS_ROLLING_DISPLAY_HIW = 'displayHIW';
export const BONUS_ROLLING_DO_NOT_DISPLAY_HIW = 'donotDisplayHIW';
